var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.76378 1.76376H3.68766V2.3097C3.68766 3.02361 4.27559 3.56954 4.9895 3.56954C5.70341 3.56954 6.24934 3.02361 6.24934 2.3097V1.76376H9.94488V2.3097C9.94488 3.02361 10.5328 3.56954 11.2467 3.56954C11.9606 3.56954 12.5486 3.02361 12.5486 2.3097V1.76376H13.4304C14.4383 1.76376 15.2362 2.56166 15.2362 3.56954V14.2362C15.2362 15.2021 14.4383 16 13.4304 16H2.76378C1.7979 16 1 15.2021 1 14.2362V3.56954C1 2.56166 1.7979 1.76376 2.76378 1.76376ZM2.04987 6.00523V14.2362C2.04987 14.6142 2.38583 14.9501 2.76378 14.9501H13.4304C13.8504 14.9501 14.1444 14.6142 14.1444 14.2362V6.00523H2.04987Z",
    fill: "#8F93AE",
    stroke: "#8F93AE",
    strokeWidth: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68764 7.85303H5.6194V9.78479H3.68764V7.85303Z",
    fill: "#8F93AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17324 7.85303H9.063V9.78479H7.17324V7.85303Z",
    fill: "#8F93AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6168 7.85303H12.5066V9.78479H10.6168V7.85303Z",
    fill: "#8F93AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68764 11.1286H5.6194V13.0604H3.68764V11.1286Z",
    fill: "#8F93AE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17324 11.1286H9.063V13.0604H7.17324V11.1286Z",
    fill: "#8F93AE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6168 11.1286H12.5066V13.0604H10.6168V11.1286Z",
    fill: "#8F93AE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.9895 0C5.40945 0 5.74541 0.335958 5.74541 0.755906V2.30971C5.74541 2.72966 5.40945 3.06562 4.9895 3.06562C4.56956 3.06562 4.1916 2.72966 4.1916 2.30971V0.755906C4.1916 0.335958 4.56956 0 4.9895 0Z",
    fill: "#8F93AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2467 0C11.6667 0 12.0026 0.335958 12.0026 0.755906V2.30971C12.0026 2.72966 11.6667 3.06562 11.2467 3.06562C10.8268 3.06562 10.4908 2.72966 10.4908 2.30971V0.755906C10.4908 0.335958 10.8268 0 11.2467 0Z",
    fill: "#8F93AE"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendarIcon.svg";
export { ForwardRef as ReactComponent };